import { render, staticRenderFns } from "./FeedbackPanel.vue?vue&type=template&id=7f87a08a&scoped=true&"
import script from "./FeedbackPanel.vue?vue&type=script&lang=js&"
export * from "./FeedbackPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPanel.vue?vue&type=style&index=0&id=7f87a08a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f87a08a",
  null
  
)

export default component.exports